import React, { createContext, useContext, useMemo } from "react";

const AttributionContext = createContext({});

/**
 * Reads URL params + referrer at first render and exposes an `attribution`
 * object matching the backend schema. No cookies, no localStorage.
 * Hard reload clears it — intentional.
 */
export function AttributionProvider({ children }) {
    const attribution = useMemo(() => {
        if (typeof window === "undefined") return {};
        const params = new URLSearchParams(window.location.search);
        const pick = (primary, fallback) => params.get(primary) || params.get(fallback) || undefined;

        const campaign_id = pick("meta_campaign_id", "campaign_id");
        const adset_id = pick("meta_adset_id", "adset_id");
        const ad_id = pick("meta_ad_id", "ad_id");
        const placement = pick("meta_placement", "placement");
        const hasMeta = Boolean(
            params.get("meta_campaign_id") || params.get("meta_adset_id") ||
            params.get("meta_ad_id") || params.get("meta_placement")
        );

        const out = {
            utm_source: params.get("utm_source") || undefined,
            utm_medium: params.get("utm_medium") || undefined,
            utm_campaign: params.get("utm_campaign") || undefined,
            utm_content: params.get("utm_content") || undefined,
            utm_term: params.get("utm_term") || undefined,
            campaign_id,
            adset_id,
            ad_id,
            placement,
            landing_url: window.location.href,
            referrer_url: document.referrer || undefined,
        };
        if (hasMeta) out.source_detail = "meta_ads";

        // Strip undefined
        Object.keys(out).forEach((k) => out[k] === undefined && delete out[k]);
        return out;
    }, []);

    return (
        <AttributionContext.Provider value={attribution}>
            {children}
        </AttributionContext.Provider>
    );
}

export function useAttribution() {
    return useContext(AttributionContext);
}
